import axios from "../../config/axiosConfig";
import {
  DATE_WISE_TRANSACTION_REPORT_REQUEST,
  DATE_WISE_TRANSACTION_REPORT_SUCCESS,
  DATE_WISE_TRANSACTION_REPORT_FAILURE,
} from "../types/date-wise-transction-report-types";

export const getDateWiseTransactionReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DATE_WISE_TRANSACTION_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
    
      const requestParams = { ...defaultParams, ...params };
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/date-wise-transaction/getReport?${queryString}`;
      console.log('Complete dateWiseTransactionReport API Request URL: ', fullUrl);
      return axios.get('/date-wise-transaction/getReport', { params: requestParams }).then((response) => {
        if (response) {
          dispatch({ 
            type: DATE_WISE_TRANSACTION_REPORT_SUCCESS, 
            payload: response 
          });
          console.log("Actions Api Call" , response);
          
          return response;
        } else {
          throw new Error(response.data?.message || 'Failed to fetch dateWiseTransactionReport report');
        }
      }).catch((error) => {
        console.error("Error fetching dateWiseTransactionReport Report:", error);
        dispatch({ 
          type: DATE_WISE_TRANSACTION_REPORT_FAILURE, 
          error: error.response?.data?.message || error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error("Error fetching dateWiseTransactionReport Report:", error);
      dispatch({ 
        type: DATE_WISE_TRANSACTION_REPORT_FAILURE, 
        error: error.response?.data?.message || error.message 
      });
      throw error;
    }
  };
};
